import LabelNew from "@/components/Common/Labels/LabelNew/LabelNew.vue";
import LabelDiscount from "@/components/Common/Labels/LabelDiscount/LabelDiscount.vue";
import AddToFavourites from "@/components/Components/AddToFavourites/AddToFavourites.vue";
import {toCurrency} from "@/utils/currency.js";


export default {
    name: 'PropertyAdMini',
    props: {
        image: {
            type: String,
            default: ''
        },
        id: {
            type: Number,
            default: null
        },
        labeldiscount: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        category: {
            type: String,
            default: ''
        },
        regularamount: {
            type: Number,
            default: ''
        },
        discountedamount: {
            type: Number,
            default: ''
        },
        labelnew: {
            type: Boolean,
            default: false
        },
        isVip: {
            type: Boolean,
            default: false
        }
    },
    components: {
        LabelNew,
        LabelDiscount,
        AddToFavourites
    },
    methods: {
        toCurrency
    },
    mounted() {
    }
}